import ReducerRegistry from '../base/redux/ReducerRegistry';
import { FACE_RECOGNITION_OFF, FACE_RECOGNITION_ON, GET_FACE_RECOGNITION_API_STATE, SET_FACE_MESH_ENABLED, SET_FACE_RECOGNITION_ENABLED } from './actionTypes';
const DEFAULT_STATE = {
    enabled: true,
    maskEnabled: false,
    isFaceAnalysisOn: true,
};
/**
 * Reduces the Redux actions of the feature features/face-recognition.
 */
ReducerRegistry.register('features/face-recognition', (state = DEFAULT_STATE, action) => {
    const { enabled, maskEnabled, isFaceAnalysisOn } = action;
    // @ts-ignore
    switch (action.type) {
        case SET_FACE_RECOGNITION_ENABLED:
            return Object.assign(Object.assign({}, state), { enabled });
        case SET_FACE_MESH_ENABLED:
            return Object.assign(Object.assign({}, state), { maskEnabled });
        case FACE_RECOGNITION_OFF:
            return Object.assign(Object.assign({}, state), { isFaceAnalysisOn });
        case FACE_RECOGNITION_ON:
            return Object.assign(Object.assign({}, state), { isFaceAnalysisOn });
        case GET_FACE_RECOGNITION_API_STATE:
            return Object.assign(Object.assign({}, state), { isFaceAnalysisOn });
        default:
            return state;
    }
});
